import { Button, Card, Col, Divider, Row } from 'antd';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import styled, { useTheme } from 'styled-components/macro';

import { PageTitle } from '../../../components/PageTitle';
import Text from '../../../components/Text';
import {
  BasePageContainer,
  CommandsContainer,
  DetailsListsContainer,
} from '../../Common/styles';

export const CancelSubscription = observer(() => {
  const history = useHistory();
  const { colors, fonts, defaultFontSize } = useTheme();

  const onKeepSubscription = useCallback(() => {
    history.push('/company/manage-subscription');
  }, [history]);

  const onConfirmCancellation = useCallback(() => {
    // intentionally no-op for now
  }, []);

  return (
    <CancelSubscriptionContainer>
      <Row>
        <CommandsContainer>
          <PageTitle title="Before You Go" />
        </CommandsContainer>
      </Row>
      <Row>
        <ContentPanelContainer>
          <Card className="gd-card">
            <Col xs={24} lg={18} xl={16}>
              <Text fontSize={14} color={colors.black06}>
                We're sorry to see you considering canceling your subscription.
              </Text>
              <Text fontSize={14} color={colors.black06}>
                We understand that your needs can change, and we appreciate the trust you've placed in us. Before you make your final decision, we wanted to remind you of the benefits that come with your subscription.
              </Text>

              <Divider />

              <SectionTitle fontFamily={fonts.bold} fontSize={defaultFontSize}>
                What You'll Lose After Cancellation
              </SectionTitle>
              <BulletList>
                {[
                  'Continued access to premium features and tools',
                  'Priority support when you need assistance',
                  'Exclusive updates and new feature releases',
                  'Saved preferences and personalized experiences',
                  'Any subscription-only benefits available on your plan',
                ].map((item, i) => (
                  <li key={i}>
                    <Text fontSize={13} color={colors.black085}>
                      {item}
                    </Text>
                  </li>
                ))}
              </BulletList>

              <Divider />

              <SectionTitle fontFamily={fonts.bold} fontSize={defaultFontSize}>
                Is There Something We Can Improve?
              </SectionTitle>
              <Text fontSize={13} color={colors.black06}>
                Your feedback helps us improve and deliver more value.{" "}
              </Text>
              <Text fontSize={13} color={colors.black06}>
                If there's a specific issue that's influencing your decision, we'd love the opportunity to address it.
              </Text>

              <Divider />

              <SectionTitle fontFamily={fonts.bold} fontSize={defaultFontSize}>
                Keep Your Subscription Active
              </SectionTitle>
              <Text fontSize={13} color={colors.black06}>
                By staying subscribed, you'll continue to have uninterrupted access to everything included in your plan and any new improvements we introduce in the future.
              </Text>

              <Divider />

              <SectionTitle fontFamily={fonts.bold} fontSize={13}>
                Need Help?
              </SectionTitle>
              <Text fontSize={13} color={colors.black06}>
                If you have questions about your subscription, billing, or available options, our support team is here to help.
              </Text>

              <ActionsContainer>
                <Button
                  type="primary"
                  className="gd-form-button gd-form-button-primary"
                  onClick={onKeepSubscription}
                >
                  Keep My Subscription
                </Button>
                <Button
                  type="text"
                  danger
                  className="gd-form-button"
                  onClick={onConfirmCancellation}
                >
                  Confirm Cancellation
                </Button>
              </ActionsContainer>
            </Col>
          </Card>
        </ContentPanelContainer>
      </Row>
    </CancelSubscriptionContainer>
  );
});

const CancelSubscriptionContainer = styled(BasePageContainer)``;

const ContentPanelContainer = styled(DetailsListsContainer)`
  margin-top: 40px;
`;

const SectionTitle = styled(Text)`
  display: block;
  margin-bottom: 12px;
`;

const BulletList = styled.ul`
  padding-left: 20px;
  margin-bottom: 0;

  & > li {
    margin-bottom: 6px;
  }
`;

const ActionsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 32px;
  padding-bottom: 8px;
`;
